import React, { useEffect, useState, useContext, memo, useCallback } from 'react';
import { ApiDispatchContext } from "../../../../context/ApiContext";
import ErrorAlert from "../../../../components/ErrorAlert";
import { getUrlParameter } from "../../../../constants/commonFunction";
import '../cardtab.css';
import path from '../../../../constants/pathConstants';
import { createStructuredSelector } from 'reselect';
import AcceptButtons from '../../../OpenCasesDetailsPage/AcceptButtons';
import { connect } from 'react-redux';
import { compose } from 'redux';
import FilterPopUp from '../../../../components/FilterPopUp';
import SuccessMessage from "../../../../components/SuccessMssgDisplay";
import Actions from '../../../../components/Actions';
import CaseBlocks from './CaseBlocks';
import AssignedInvestigators from './AssignedInvestigators';
import Loader from '../../../../components/Loader';
import { useLocation, useNavigate } from "react-router-dom";
import { mandatoryBlocksIdsForHealth, mandatoryBlocksIdsForOD, mandatoryBlocksIdsForTP } from '../../../../constants/constants';
import makeSelectAllottedCasesDetailsPage from '../../selectors';
import { setApiReRender } from '../../actions';
import { set } from 'date-fns/fp';

export const Investigation = ({ allottedCaseDetailsPage, setApiReRender }) => {
  const api = useContext(ApiDispatchContext);
  const [modal, setModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalBody, setModalBody] = useState("");
  const toggle = () => setModal(!modal);
  const [itemsToDisplay, setitemsToDisplay] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [blockOpen, setBlockOpen] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [actionDisable, setActionDisable] = useState(false);
  const [reRender, setReRender] = useState(false)
  const location = useLocation();
  let casid = Number(getUrlParameter('case'));
  let subProduct = getUrlParameter('subProduct');
  let lob = getUrlParameter('lob');
  let redirectedFrom = getUrlParameter('redirectedFrom');
  const lobType = localStorage.getItem("lobType");

  const { apiReRender } = allottedCaseDetailsPage
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (casid) {
      let payload = {
        "caseId": casid,
        "assignedToInvestigator": true,
        "page": 1,
        "pageSize": 10,
      }
      api.getAssignedInvestigatorsDetails(payload).then(data => {
        setShowLoader(true);
        if (data.data && data.data.success) {
          if (Object.keys(data.data.data).length === 0) {
            navigate(path.ALLOTTED_CASES)  // if case withdraw and in bucket there is no investigator assign then we navigate to alloted_cases
          }
          setShowLoader(false);
          setitemsToDisplay(data.data.data);
          checkActionDisable(data.data.data.assigned_blocks && data.data.data.assigned_blocks.blocks.length > 0 ? data.data.data.assigned_blocks.blocks : []);
          if (redirectedFrom && redirectedFrom === "AssignedBlocks") {
            setBlockOpen(true);
          }
          if (apiReRender || reRender) {
            setApiReRender(false)
            setReRender(false)
          }
        } else {
          setModalTitle("Failed to load allotted cases data.");
          if (data.data.error && data.data.message) {
            setModalBody(data.data.message)
          }
          else {
            setModalBody('Please try after sometime');
          }
          toggle();
          setShowLoader(false);
        }
      }).catch(err => {
        setModalTitle("Failed to load allotted cases data.");
        if (err && err.response && err.response.data && err.response.data.message) {
          setModalBody(err.response.data.message);
        } else {
          setModalBody('Please try after sometime.');
        }
        toggle();
        setShowLoader(false);
      })
    }
  }, [casid, reRender, apiReRender]);

  const checkActionDisable = useCallback((blocksArr) => {
    let count = 0;
    if (["OD", "Motor/OD"].includes(subProduct)) {
      blocksArr ?.length > 0 && blocksArr ?.forEach((data) => {
        if (mandatoryBlocksIdsForOD.includes(data ?.block_master_id)) {
          if (data ?.block_status === "inProgress" || data ?.block_status === "pending") {
            count++;
          }
        }
      });
    } else if (["TP", "Motor/TP"].includes(subProduct)) {
      blocksArr ?.length > 0 && blocksArr ?.forEach((data) => {
        if (mandatoryBlocksIdsForTP.includes(data ?.block_master_id)) {
          if (data ?.block_status === "inProgress" || data ?.block_status === "pending") {
            count++;
          }
        }
      })} else if (lob === "AH" || lobType === "A&H") {
        blocksArr ?.length > 0 && blocksArr ?.forEach((data) => {
          if (mandatoryBlocksIdsForHealth.includes(data ?.block_master_id)) {
            if (data ?.block_status === "inProgress" || data ?.block_status === "pending") {
              count++;
            }
          }
        })} else {
      blocksArr ?.length > 0 && blocksArr ?.forEach((data) => {
        if (data ?.block_status === "inProgress" || data ?.block_status === "pending") {
          count++;
        }
      });
    }
    if (count == 0) {
      setActionDisable(false);
    } else {
      setActionDisable(true);
    }
  }, [subProduct]);

  const handleChange = useCallback((event) => {
    let tempdata = {};
    Object.assign(tempdata, itemsToDisplay);
    tempdata['remark'] = event.target.value;
    setitemsToDisplay(tempdata);
  }, [itemsToDisplay]);

  const Onviewclick = useCallback((blockid, blockname, flag) => {
    navigate(path.ASSIGNED_BLOCCKS_ALLOTTED_CASES + '?' + btoa('case=' + casid + '&lob=' + lob + '&subProduct=' + subProduct + '&blockid=' + blockid + '&blockname=' + blockname + '&multiform=' + flag));
  }, [casid, subProduct]);

  const submitRemark = useCallback((value) => {
    setShowSuccessMessage(false);
    let payload = {
      "caseId": casid,
      "remark": value
    }
    api.submitCaseRemark(payload).then(data => {
      if (data.data && data.data.success) {
        setShowSuccessMessage("Records Updated Successfully!");
      } else {
        setModalTitle("Failed to Save remark Data.");
        if (data.data.error && data.data.message) {
          setModalBody(data.data.message)
        } else {
          setModalBody('Please try after sometime');
        }
        toggle();
      }
    }).catch(err => {
      setModalTitle("Failed to Save remark Data.");
      if (err && err.response && err.response.data && err.response.data.message) {
        setModalBody(err.response.data.message);
      } else {
        setModalBody('Please try after sometime.');
      }
      toggle();
    })
  }, [casid]);

  const filterToggle = useCallback(() => {
    setOpen(!open);
  }, [open]);

  const onWithdrawInvestigatorHandler = (caseId, investigatorId) => {
    const payload = {
      caseId: caseId,
      investigatorId: investigatorId

    }
    api.withdrawInvestigator(payload).then((res) => {
      if (res.data.success) {
        setShowSuccessMessage(res.data.message);
        setReRender(true)
      }
      if (res.data.error && res.data.message) {
        setModalBody(res.data.message)
        toggle();
      }
    }).catch((err) => {
      if (err && err.response && err.response.data && err.response.data.message) {
        setModalBody(err.response.data.message);
      } else {
        setModalBody('Please try after sometime.');
      }
      toggle();
    })
  }
  // path.ALLOTTED_CASES

  return (
    <div className='allotedclaim-data'>
      <p className='assignedByString'>Assigned By: {itemsToDisplay?.assigned_by}</p>
      <CaseBlocks blockOpen={blockOpen} assigned_blocks={itemsToDisplay.assigned_blocks} remark={itemsToDisplay.remark ? itemsToDisplay.remark : ""} Onviewclick={Onviewclick} submitRemark={submitRemark} handleChange={handleChange} />
      {itemsToDisplay.assigned_investigators && itemsToDisplay.assigned_investigators.count && <AssignedInvestigators assigned_investigators={itemsToDisplay.assigned_investigators} onWithdrawInvestigatorHandler={(caseId, investigatorId) => onWithdrawInvestigatorHandler(caseId, investigatorId)} />}
      <div className="AcceptButtons-ContainerParent" style={{ width: '100%' }}>
        <div className="AcceptButtons-Container">
          <AcceptButtons disabled={actionDisable} background={actionDisable ? "#F9CACB" : '#E42125'} color={actionDisable ? '#E42125' : '#FFFFFF'} data-testid="save-button" onClick={filterToggle}>Action</AcceptButtons>
        </div>
      </div>
      {open && (<FilterPopUp open={open} backgroundColor={'#8F949B80'} filterToggle={filterToggle} >
        <Actions caseType="allottedcase" subProduct={subProduct} />
      </FilterPopUp>)}
      {showLoader && <Loader />}
      <ErrorAlert
        modal={modal}
        toggle={toggle}
        modalTitle={modalTitle}
        modalBody={modalBody}
      />
      {showSuccessMessage && (
        <SuccessMessage message={showSuccessMessage} delay={3000} />
      )}
    </div>
  )
}

const mapStateToProps = createStructuredSelector({
  allottedCaseDetailsPage: makeSelectAllottedCasesDetailsPage(),
});

export function mapDispatchToProps(dispatch) {
  return {
    setApiReRender: (val) => dispatch(setApiReRender(val)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect, memo, )(Investigation);